import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Instagram, Linkedin, Mail, Phone, MapPin } from 'lucide-react';
export function Footer() {
  return <footer className="bg-navy text-white pt-20 pb-10 border-t border-white/10" data-id="element-61" data-mp="32o4deh7i4k9p">
      <div className="container mx-auto px-6 md:px-12" data-id="element-62" data-mp="32m1c310wf4po">
        <div className="grid grid-cols-2 lg:grid-cols-5 gap-8 lg:gap-12 mb-16" data-id="element-63" data-mp="36q953aee36tp">
          <div className="col-span-2" data-id="element-64" data-mp="3uesbtlhsjbjo">
            <Link to="/" className="mb-6 block" data-id="element-65" data-mp="3uftqdzy0mg65">
              <img src="https://cdn.magicpatterns.com/uploads/hYuXCXijE8xA4tYjBeZUog/ChatGPT_Image_Jul_24,_2026,_02_58_54_AM.png" alt="Poch Global Logo" className="h-24 w-auto object-contain" data-id="element-66" data-mp="398xsbsbb070" />
            </Link>
            <p className="text-white/60 mb-8 max-w-sm" data-id="element-67" data-mp="29z6v4e3aingy">
              Connecting people worldwide to African heritage, culture,
              education, and innovation. Empowering youth and building bridges.
            </p>
            <div className="flex gap-4" data-id="element-68" data-mp="3l90ozzfy550u">
              {[Facebook, Twitter, Instagram, Linkedin].map((Icon, i) => <a key={i} href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-white/60 hover:bg-gold hover:text-white transition-all" data-id="element-69" data-mp="3gbikcl8ypbyn" data-mpi={i}>
                  <Icon className="w-5 h-5" data-id="element-70" data-mp="3qazo2x4nlfrz" />
                </a>)}
            </div>
          </div>

          <div data-id="element-71" data-mp="3473nkkfm3xo">
            <h4 className="font-bold text-lg mb-6" data-id="element-72" data-mp="34p9n8wwbwis">Quick Links</h4>
            <ul className="space-y-4 text-white/60" data-id="element-73" data-mp="322zr2mj94xe">
              <li data-id="element-74" data-mp="hrigrqw9hvzw">
                <Link to="/" className="hover:text-gold transition-colors" data-id="element-75" data-mp="hs1x5369kcbt">
                  Home
                </Link>
              </li>
              <li data-id="element-76" data-mp="qt8fziwdxz88">
                <Link to="/about" className="hover:text-gold transition-colors" data-id="element-77" data-mp="qsqfub6lr0v1">
                  About Us
                </Link>
              </li>
              <li data-id="element-78" data-mp="mptrs4yamcjp">
                <Link to="/programs" className="hover:text-gold transition-colors" data-id="element-79" data-mp="tv4iroyaqfyo">
                  Programs
                </Link>
              </li>
              <li data-id="element-80" data-mp="13tkclzopk3bv">
                <Link to="/events" className="hover:text-gold transition-colors" data-id="element-81" data-mp="13t0t4ejet6vq">
                  Events
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-82" data-mp="1cl2wakkv519p">
            <h4 className="font-bold text-lg mb-6" data-id="element-83" data-mp="1cnoz66wt6sll">Get Involved</h4>
            <ul className="space-y-4 text-white/60" data-id="element-84" data-mp="1hje0aeoh8hk0">
              <li data-id="element-85" data-mp="1mk1rb0cpgye8">
                <Link to="/donate" className="hover:text-gold transition-colors" data-id="element-86" data-mp="1mjikaeolfuez">
                  Donate
                </Link>
              </li>
              <li data-id="element-87" data-mp="3obx1tcn86wuv">
                <Link to="/volunteer" className="hover:text-gold transition-colors" data-id="element-88" data-mp="3ocghempel95q">
                  Volunteer
                </Link>
              </li>
              <li data-id="element-89" data-mp="2agomxepfekgy">
                <Link to="/contact" className="hover:text-gold transition-colors" data-id="element-90" data-mp="2ah87722jtky5">
                  Partner
                </Link>
              </li>
              <li data-id="element-91" data-mp="21kpbji2xnixv">
                <Link to="/shop" className="hover:text-gold transition-colors" data-id="element-92" data-mp="1wnp5h7632g6r">
                  Shop
                </Link>
              </li>
            </ul>
          </div>

          <div className="col-span-2 lg:col-span-1" data-id="element-93" data-mp="2tbvh4e1fa8uj">
            <h4 className="font-bold text-lg mb-6" data-id="element-94" data-mp="2pdfp1vqhiaa9">Resources</h4>
            <ul className="space-y-4 text-white/60" data-id="element-95" data-mp="2kdb51vqdaxfa">
              <li data-id="element-96" data-mp="2kbqai641zehf">
                <Link to="/blog" className="hover:text-gold transition-colors" data-id="element-97" data-mp="2kfe6rd0vuezu">
                  Blog & News
                </Link>
              </li>
              <li data-id="element-98" data-mp="18yeeghejc05t">
                <Link to="/contact" className="hover:text-gold transition-colors" data-id="element-99" data-mp="18yxlh32nd452">
                  Contact
                </Link>
              </li>
              <li className="flex items-center gap-3 mt-6" data-id="element-100" data-mp="2ru6d7qgvz7i0">
                <Mail className="w-5 h-5 text-gold" data-id="element-101" data-mp="2wmziqgk6ijv5" /> hello@pochglobal.org
              </li>
              <li className="flex items-center gap-3" data-id="element-102" data-mp="2ivb7sglo21fr">
                <Phone className="w-5 h-5 text-gold" data-id="element-103" data-mp="2iww2c67zdkdm" /> +1 (555) 123-4567
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-white/40 text-sm" data-id="element-104" data-mp="3bjzz5nwx6seb">
          <p data-id="element-105" data-mp="3fk0pa5tdss17">
            &copy; {new Date().getFullYear()} Poch Global. All rights reserved.
          </p>
          <div className="flex gap-6" data-id="element-106" data-mp="31l108x1yib4i">
            <Link to="/terms" className="hover:text-white transition-colors" data-id="element-107" data-mp="36knd35dvhpcs">
              Terms & Conditions
            </Link>
            <Link to="/privacy" className="hover:text-white transition-colors" data-id="element-108" data-mp="1q648vgiav9tz">
              Privacy Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}